<template>
  <div>
    <van-nav-bar
      title="入库查询"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />
    <van-button style="width: 100%;" @click="searchshow=true" plain type="info">点击搜索产品</van-button>

    <van-overlay :show="searchshow" :lock-scroll="false" >

      <div style="width: 90%; height: 90%;margin:0 auto;background-color: aliceblue; position: absolute;top: 5%;left: 5%; overflow-y: auto; overflow-x: hidden;-webkit-overflow-scrolling: touch;" >
         <van-sticky>
          <van-search show-action v-model="pdvalue" placeholder="请输入搜索关键词" @search="searchproducts"     @cancel="searchshow=false" />
         </van-sticky>
          <van-swipe-cell v-for="item in pdlist" :key="item.id">

            <van-cell :title="item.name"  :value="'库存：'+item.remaining_count" :label="'价格线：'+item.price_line" />
            <template #right>
              <van-button square type="primary" text="选择" style="height: 100%;" @click="selectpd(item)"/>
            </template>
          </van-swipe-cell>



      </div>

    </van-overlay>
    <div @scroll="pageScroll" style="overflow-y:scroll;height: 844px;">
      <van-cell-group inset style="margin-top:10px;" v-for="item in rukudata" :key="item.inventoryid" label-class="celllabel" >
        <van-cell :value="item.create_datetime" />
        <van-cell :title="item.productname" :value="'入库: '+item.total_count+'/ 剩余:'+item.remaining_count" />
        <van-cell :title="item.factoryname" :value="item.dis_type" />
        <van-cell :title="'成本单价：'+item.cost_unit" :value="'成本总价'+item.cost_total"/>
      </van-cell-group>


    </div>


  </div>
</template>

<script>
  import * as Api from './api.js'
import { Toast } from 'vant';
  export default {
    name: 'RukuList',
    data () {
      return {
        value:'',
        rukudata:[],
        pageNo:1,
        isnext:false,
        searchshow:false,
        pdvalue:'',
        pdlist:[],
        pdid:''



      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
      this.getrukudata(1)
    },
    methods:{
      getrukudata(pageno){
        let query = {
          limit:50,
          page:pageno,
          product:this.pdid,
          ordering:'-id'
        }
        if (pageno==1){
          this.rukudata = []
        }

        console.log(query)
        Api.getinventory(query).then(res=>{
          this.isnext = res.data.is_next
          this.rukudata = this.rukudata.concat(res.data.data)


          console.log(this.rukudata)
        })

      },
      onClickLeft(){
        this.$router.push({path:'/'})
      },
      pageScroll(e){
            // 滑动条滚动时，距离顶部距离
            var scrollTop=e.target.scrollTop
            // 可视区高度
            var windowHeight=e.target.clientHeight
            // 滑动条总高度
            var scrollHeight=e.target.scrollHeight
            // 滑动条到达底部的条件
            if(scrollTop+windowHeight==scrollHeight){
              console.log(this.isnext)
              if(this.isnext){

                this.pageNo++
                // 获取下一页数据
                this.getNext()
                console.log('获取下一页数据')
              }else{
                Toast('已经到底了')
              }
            }
      },
      getNext(){
        console.log(this.pageNo)
        this.getrukudata(this.pageNo)
      },
      searchproducts(){
        let query={
          limit:999,
          name:this.pdvalue
        }

        Api.getproducts(query).then(res=>{
          this.pdlist = res.data.data
        })
      },
      selectpd(item){
        this.pdid = item.id
        this.searchshow = false
        this.getrukudata(1)
      },

    }
  }

</script>

<style>
  .celllabel{
    width:100%
  }
</style>



// WEBPACK FOOTER //
// src/views/shangwuviews/rukulist/index.vue